import { cn } from "../lib/cn";

export interface TabItem {
  label: string;
  value: string;
}

export interface TabsProps {
  tabs: TabItem[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function Tabs({ tabs, value, onChange, className }: TabsProps) {
  return (
    <div
      className={cn("border-gold-dim flex gap-0 border-b", className)}
      role="tablist"
    >
      {tabs.map((tab) => {
        const isActive = tab.value === value;
        return (
          <button
            key={tab.value}
            role="tab"
            aria-selected={isActive}
            onClick={() => {
              onChange(tab.value);
            }}
            className={cn(
              "px-4 py-3 font-mono text-[11px] uppercase tracking-[0.14em] transition-colors duration-200",
              "-mb-px border-b-2",
              isActive
                ? "text-gold border-gold bg-[rgba(201,168,76,0.06)]"
                : "text-text-muted hover:text-text border-transparent",
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
